import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconCloseCircle: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0.25C4.61406 0.25 0.25 4.61406 0.25 10C0.25 15.3859 4.61406 19.75 10 19.75C15.3859 19.75 19.75 15.3859 19.75 10C19.75 4.61406 15.3859 0.25 10 0.25ZM12.4703 13.5297L10 11.0594L7.52969 13.5297C7.23906 13.8203 6.76094 13.8203 6.47031 13.5297C6.325 13.3844 6.25 13.1922 6.25 13C6.25 12.8078 6.325 12.6156 6.47031 12.4703L8.94063 10L6.47031 7.52969C6.325 7.38438 6.25 7.19219 6.25 7C6.25 6.80781 6.325 6.61562 6.47031 6.47031C6.76094 6.17969 7.23906 6.17969 7.52969 6.47031L10 8.94063L12.4703 6.47031C12.7609 6.17969 13.2391 6.17969 13.5297 6.47031C13.8203 6.76094 13.8203 7.23906 13.5297 7.52969L11.0594 10L13.5297 12.4703C13.8203 12.7609 13.8203 13.2391 13.5297 13.5297C13.2391 13.825 12.7609 13.825 12.4703 13.5297Z"
    />
  </Icon>
);

export default IconCloseCircle;
